@if (_version) {
  <div class="row">
    <div class="col-md-6 col-sm-12">
      <cap-kopfdatenelement [histInfo]="_version.histInfo" label="gebaeudeart">
        {{ gebaeudeArtString }}
      </cap-kopfdatenelement>
      <cap-kopfdatenelement [histInfo]="_version.histInfo" label="Gebaeudeflaeche">
        @if (_version.totalQuadratmeter) {
          <span> {{ _version.totalQuadratmeter | decimalHochkomma }}&nbsp;m² </span>
        }
      </cap-kopfdatenelement>
      <cap-kopfdatenelement
        [histInfo]="_version.histInfo"
        [value]="_version.versicherungsNummer"
        label="Versicherungsnummer"></cap-kopfdatenelement>
      <cap-kopfdatenelement [histInfo]="_version.histInfo" label="EGID">
        @if (hasExternalGwr) {
          <a
            (click)="openExternalGWRLink(_version.gwrEgid.toString())"
            [ngbTooltip]="'DetailsZuGebaeudeWohnungsregister' | translate"
            container="body"
            style="cursor: pointer">
            {{ _version.gwrEgid }}
          </a>
        }
        @if (!hasExternalGwr) {
          <span>
            {{ _version.gwrEgid }}
          </span>
        }
        <cap-gwr-link [egid]="_version.gwrEgid?.toString()"></cap-gwr-link>
      </cap-kopfdatenelement>
      @if (_version.mKantGid.access !== "DEACTIVATED") {
        <cap-kopfdatenelement [histInfo]="_version.histInfo" label="gebaeude.BE-GID">
          {{ _version.kantGid }}
        </cap-kopfdatenelement>
      }
      <cap-gebaeude-gehoert-zu-sdr
        [gebaeude]="gebaeude"
        [histInfo]="_version.histInfo"
        [isKopfdatenElement]="true"></cap-gebaeude-gehoert-zu-sdr>
    </div>
    <div class="col-md-6 col-sm-12">
      <cap-kopfdatenelement [histInfo]="_version.histInfo" label="Unterirdisch">
        {{ _version?.unterirdisch | yesNo }}
      </cap-kopfdatenelement>
      <cap-kopfdatenelement [histInfo]="_version.histInfo" label="Projektiert">
        {{ _version?.projektiert | yesNo }}
      </cap-kopfdatenelement>
      @if (_version.mEinzelobjekt.access !== "DEACTIVATED") {
        <cap-kopfdatenelement [histInfo]="_version.histInfo" label="Einzelobjekt">
          {{ _version?.einzelobjekt | yesNo }}
        </cap-kopfdatenelement>
      }
      @if (_version.mHistInfo?.access !== "DEACTIVATED") {
        <cap-kopfdatenelement label="ErstelltMit">
          <cap-kompakt-timepoint [item]="_version.histInfo?.vonTimePoint"></cap-kompakt-timepoint>
        </cap-kopfdatenelement>
      }
      @if (_version.mHistInfo?.access !== "DEACTIVATED") {
        <cap-kopfdatenelement label="GestrichenMit">
          <cap-kompakt-timepoint [item]="_version.histInfo?.bisTimePoint"></cap-kompakt-timepoint>
        </cap-kopfdatenelement>
      }
    </div>
  </div>
}
